import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';

import { requiredWhenPresent } from '../../shared/propTypes';

const DeleteTagModal = ({
  hideModal,
  entityToRemove,
  periodName,
  categoryName,
  isVisible,
  removeEntity,
  isDeletingInProgress,
}) => {
  const removeTag = useCallback(() => {
    if (entityToRemove) {
      removeEntity({ ...entityToRemove, periodName, categoryName }, { rowIndex: entityToRemove.rowIndex });
    }
  }, [removeEntity, entityToRemove, periodName, categoryName]);

  return (
    <Modal
      className="delete-tag-modal"
      title="Delete Tag"
      dismissText="Cancel"
      submitText="Yes"
      isSubmitting={isDeletingInProgress}
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeTag}
      isVisible={isVisible}
    >
      { entityToRemove
        ? (
          <div>
            Are you sure you want to delete: <br/><br/>
            Tag Name: {entityToRemove.tagName}<br/>
            Period: {periodName}<br/>
            Category Name: {categoryName}<br/>
          </div>
        )
        : null
      }
    </Modal>
  );
};

DeleteTagModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  periodName: requiredWhenPresent(['isVisible'], PropTypes.string),
  categoryName: requiredWhenPresent(['isVisible'], PropTypes.string),
  entityToRemove: requiredWhenPresent(['isVisible'], PropTypes.shape({
    tagName: PropTypes.string.isRequired,
    rowIndex: PropTypes.number.isRequired,
  })),
  isVisible: PropTypes.bool,
  isDeletingInProgress: PropTypes.bool,
};

export default DeleteTagModal;
